export default __webpack_public_path__ + "static/media/043-land_2.794b5441.svg";